<template>
  <div>
    <span v-if="hasBadge" class="table-head-badge">
      <span v-if="isUsed" class="icon">이용중</span>
      <span v-else-if="isUpcoming" class="icon">결제 예약</span>
      <span v-else-if="isRecommend" class="icon icon-supplant">추천</span>
    </span>

    <span class="product-name" v-html="productName"></span>

    <span v-if="hasDisplayAmount" class="before-price">
      &#65510;{{ setNumberCommas(displayAmount) }}
    </span>

    <button
      v-for="(product, index) in purchaseAmountInfoList"
      :id="product.productid"
      :key="`amount_button_${index}`"
      ref="purchaseButton"
      type="button"
      class="btn"
      :class="{ selected: product.productid === selectedProductId }"
      @click="voucherPurchase(voucher, product)"
    >
      <VoucherTableHeadButton :product-info="product" />
    </button>
  </div>
</template>
<script setup>
  import { computed, defineProps, defineEmits } from 'vue'
  import { setNumberCommas } from '@/common/utils/common'
  import VoucherTableHeadButton from '@/components/voucher/VoucherTableHeadButton.vue'
  import { getTextBreaks } from '@/common/utils/string-manipulation/get-text-breaks'

  const props = defineProps({
    voucher: {
      type: Object,
      default: () => ({}),
    },
    selectedProductId: {
      type: String,
      default: null,
    },
  })
  const emit = defineEmits(['on-click-product'])

  const concurrency = computed(() => props.voucher?.concurrency?.[0] ?? {})
  const isUsed = computed(() => concurrency.value?.in_use ?? false)
  const isUpcoming = computed(() => concurrency.value?.is_upcoming ?? false)
  const isRecommend = computed(() => concurrency.value?.recommendation ?? false)
  const productName = computed(
    () => getTextBreaks(concurrency.value?.product_name) ?? '',
  )
  const displayAmount = computed(() => concurrency.value?.displayamount ?? '')
  const purchaseAmountInfoList = computed(
    () => concurrency.value?.purchase_amount_info_list ?? [],
  )

  const hasDisplayAmount = computed(() => displayAmount.value !== '')
  const hasBadge = computed(
    () => isUsed.value || isUpcoming.value || isRecommend.value,
  )

  const voucherPurchase = (voucher, amountInfoData) => {
    emit('on-click-product', voucher, amountInfoData)
  }
</script>
